module.exports = __webpack_public_path__ + "static/media/details.1de80b77.svg";